import { useEffect } from 'react';

import { ReceivePacketCallback } from '../../../types';
import { useXpointLiteDownloadSDK } from './useXpointLiteDownloadSDK';
import { useXpointLiteRequestPacket } from './useXpointLiteRequestPacket';
import { useXpointLiteConnect } from './useXpointLiteConnect';

import * as Types from '../types';

export const useXpointLiteIntegration = ({
    sdk,
    enable,
    sdkUrl,
    transactionID,
    onConnect,
    receivePacket,
    geolocationType
}: {
    sdk: Types.XPointLiteSDKInstance | null;
    enable: boolean;
    sdkUrl: string;
    transactionID: string | null;
    onConnect: CallableFunction;
    receivePacket: ReceivePacketCallback;
    geolocationType: string;
}) => {
    const downloadXpointLiteSDK = useXpointLiteDownloadSDK({ sdkUrl });
    const xpointConnect = useXpointLiteConnect({
        sdk,
        onConnect
    });
    const requestXpointLitePacket = useXpointLiteRequestPacket({
        sdk,
        transactionID,
        geolocationType,
        receivePacket
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        xpointConnect();
    }, [sdk, enable, xpointConnect]);

    return {
        requestXpointLitePacket,
        downloadXpointLiteSDK
    };
};
